import { periodDates, periodNumberFor, periodRangeLabel, type PeriodDateSkeleton } from '../../lib/payPeriods'

/**
 * The pay period after the current one (payPeriod19.ts): the one pay
 * period this pilot's data reaches beyond the current one, generated the
 * same way from the same real-clock anchor, so it always names the
 * period right after whichever one is current rather than a fixed "Pay
 * Period 20." Split out so AgentCopySchedulePage.tsx and the supervisor
 * planning board can both build from these same 14 dates rather than two
 * hand-typed copies that could drift apart. Only a bare date skeleton:
 * per-person content is synthesized from it on the fly (defaultDay()
 * below, and its supervisor-side equivalents), never hand-authored here.
 */
const now = new Date()
const REAL_TODAY_ISO = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
const NEXT_PERIOD_NUMBER = periodNumberFor(REAL_TODAY_ISO) + 1

export const PAY_PERIOD_20 = { label: `Pay Period ${NEXT_PERIOD_NUMBER}`, range: periodRangeLabel(NEXT_PERIOD_NUMBER) }

export const PAY_PERIOD_20_DATES: PeriodDateSkeleton[] = periodDates(NEXT_PERIOD_NUMBER)
